import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';

import { CanDeactivateGuard } from '../../classes/canDeactivate';

import { WorkShiftComponent } from './work-shift/work-shift.component';
import { WORK_SHIFT_PATHS } from './work-shift';
import { BrigadesComponent } from './work-shift/components/brigades/brigades.component';
import { EmployeeStatusesComponent } from './work-shift/components/employee-statuses/employee-statuses.component';
import { WorkShiftSectorsComponent } from './work-shift/components/work-shift-sectors/work-shift-sectors.component';
import { MonitoringComponent } from './work-shift/components/monitoring/monitoring.component';
import { TicketsAssignComponent } from './work-shift/components/tickets-assign/tickets-assign.component';
import { TicketsAssignComponent as TicketsAssignNewComponent } from './work-shift/components/tickets-assign-new/tickets-assign.component';
import { AuthGuard } from '../auth/auth.guard.service';
import { MonitoringWrapperComponent } from './work-shift/components/monitoring-wrapper/monitoring-wrapper.component';
import { SectorIdResolver } from './work-shift/resolvers/sector-id.resolver';

const routes: Routes = [
  {
    path: WORK_SHIFT_PATHS.work_shift,
    component: WorkShiftComponent,
    canActivate: [AuthGuard],
    data: { animation: 'WorkShiftPage', permission: null },
    children: [
      {
        path: WORK_SHIFT_PATHS.work_shift_sector,
        component: WorkShiftSectorsComponent,
        canActivate: [AuthGuard],
        data: {
          animation: 'WorkShiftSectorsPage',
          permission: 'work_shift.get',
        },
        children: [
          {
            path: WORK_SHIFT_PATHS.work_shift_worker_statuses,
            component: EmployeeStatusesComponent,
            canActivate: [AuthGuard],
            data: {
              animation: 'WorkShiftWorkerStatusesPage',
              name: 'work_shift_worker_statuses',
              permission: 'schedule_worklog.get',
            },
          },
          {
            path: WORK_SHIFT_PATHS.work_shift_brigades,
            component: BrigadesComponent,
            canActivate: [AuthGuard],
            data: {
              animation: 'WorkShiftBrigadesPage',
              name: 'work_shift_brigades',
              permission: 'brigade.get',
            },
          },
          {
            path: WORK_SHIFT_PATHS.work_shift_tickets,
            component: TicketsAssignComponent,
            canActivate: [AuthGuard],
            canDeactivate: [CanDeactivateGuard],
            resolve: {
              sectorId: SectorIdResolver,
            },
            data: {
              animation: 'WorkShiftTicketsPage',
              name: 'work_shift_tickets',
              navigateTo: [WORK_SHIFT_PATHS.work_shift_tickets],
              permission: 'ticket.get',
            },
          },
          {
            path: WORK_SHIFT_PATHS.work_shift_tickets_new,
            component: TicketsAssignNewComponent,
            canActivate: [AuthGuard],
            canDeactivate: [CanDeactivateGuard],
            resolve: {
              sectorId: SectorIdResolver,
            },
            data: {
              animation: 'WorkShiftTicketsNewPage',
              name: 'work_shift_tickets_new',
              navigateTo: [WORK_SHIFT_PATHS.work_shift_tickets_new],
              permission: 'ticket.get',
            },
          },
          {
            path: WORK_SHIFT_PATHS.work_shift_monitoring,
            component: MonitoringWrapperComponent,
            canActivate: [AuthGuard],
            canDeactivate: [CanDeactivateGuard],
            data: {
              permission: 'ticket.monitoring.get',
              name: 'work_shift_monitoring',
            },
            children: [
              {
                path: '',
                pathMatch: 'full',
                redirectTo: WORK_SHIFT_PATHS.work_shift_monitoring_list,
              },
              {
                path: WORK_SHIFT_PATHS.work_shift_monitoring_list,
                component: MonitoringComponent,
                data: {
                  animation: 'WorkShiftMonitoringListPage',
                  name: 'work_shift_monitoring_list',
                },
              },
              {
                path: WORK_SHIFT_PATHS.work_shift_monitoring_map,
                component: TicketsAssignComponent,
                canActivate: [AuthGuard],
                resolve: {
                  sectorId: SectorIdResolver,
                },
                data: {
                  animation: 'WorkShiftTicketsPage',
                  name: 'map',
                  navigateTo: [WORK_SHIFT_PATHS.work_shift_monitoring, WORK_SHIFT_PATHS.work_shift_monitoring_map],
                  permission: 'ticket.get',
                },
              },
            ],
          },
          {
            path: WORK_SHIFT_PATHS.work_shift_monitoring,
            component: MonitoringComponent,
            canActivate: [AuthGuard],
            canDeactivate: [CanDeactivateGuard],
            data: {
              animation: 'WorkShiftMonitoringPage',
              name: 'work_shift_monitoring',
              permission: 'ticket.monitoring.get',
            },
          },
        ],
      },
    ],
  },
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule],
})
export class WorkShiftRoutingModule {}
